var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4366 0H5.65298C2.53141 0 0 2.51888 0 5.625V12.375C0 15.4811 2.53141 18 5.65298 18H12.4366C15.5581 18 18.0895 15.4811 18.0895 12.375V5.625C18.0895 2.51888 15.5581 0 12.4366 0ZM16.3936 12.375C16.3936 14.5462 14.6186 16.3125 12.4366 16.3125H5.65298C3.47093 16.3125 1.69589 14.5462 1.69589 12.375V5.625C1.69589 3.45375 3.47093 1.6875 5.65298 1.6875H12.4366C14.6186 1.6875 16.3936 3.45375 16.3936 5.625V12.375Z",
    fill: "#000B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05461 4.51025C6.55712 4.51025 4.53223 6.52513 4.53223 9.01025C4.53223 11.4954 6.55712 13.5103 9.05461 13.5103C11.5521 13.5103 13.577 11.4954 13.577 9.01025C13.577 6.52513 11.5521 4.51025 9.05461 4.51025ZM9.05461 11.8228C7.49665 11.8228 6.22812 10.5605 6.22812 9.01025C6.22812 7.45888 7.49665 6.19775 9.05461 6.19775C10.6126 6.19775 11.8811 7.45888 11.8811 9.01025C11.8811 10.5605 10.6126 11.8228 9.05461 11.8228Z",
    fill: "#000B33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8932 4.77652C14.2269 4.77652 14.4973 4.50737 14.4973 4.17537C14.4973 3.84336 14.2269 3.57422 13.8932 3.57422C13.5595 3.57422 13.2891 3.84336 13.2891 4.17537C13.2891 4.50737 13.5595 4.77652 13.8932 4.77652Z",
    fill: "#000B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d22630fb4003c373f819c81f04c6341a.svg";
export { ForwardRef as ReactComponent };